"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = keyOf;

var _defs = _interopRequireDefault(require("../_core/defs"));

// iterates over data keys looking for a property with given value
// and returns a key of found property
function keyOf(value) {
  var def = _defs["default"].get(this);
  /* istanbul ignore if */


  if (!def) {
    return null;
  }

  var keysArray = Object.keys(def.keys);

  for (var i = 0; i < keysArray.length; i++) {
    var key = keysArray[i];

    if (this[key] === value) {
      return key;
    }
  }

  return null;
}
//# sourceMappingURL=keyof.js.map